(() => {
  customElements.whenDefined('product-info').then(() => {
    const prototype = customElements.get('product-info').prototype;
    if (prototype.jbGroupedMediaInstalled) return;
    const updateMedia = prototype.updateMedia;
    prototype.updateMedia = function (html, variantFeaturedMediaId) {
      const current = this.querySelector('media-gallery');
      const next = html.querySelector('media-gallery');
      if (!current || next?.dataset.jbVariantGroup !== 'true') {
        return updateMedia.call(this, html, variantFeaturedMediaId);
      }
      const gallery = next.cloneNode(true);
      gallery.querySelectorAll('.scroll-trigger').forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
      current.replaceWith(gallery);
      const modal = this.productModal?.querySelector('.product-media-modal__content');
      const nextModal = html.querySelector('product-modal .product-media-modal__content');
      if (modal && nextModal) modal.replaceChildren(...nextModal.cloneNode(true).childNodes);
      const first = gallery.querySelector('[data-media-id]');
      if (first) gallery.setActiveMedia?.(first.dataset.mediaId, false);
      if (this.hasAttribute('data-zoom-on-hover') && typeof enableZoomOnHover === 'function') {
        enableZoomOnHover(2);
      }
    };
    prototype.jbGroupedMediaInstalled = true;
  });
})();
